module.exports = __webpack_public_path__ + "img/ruben.35b2c880.png";